import React, { useEffect, useState } from "react";
import { setBackHandler, setHeaderTitle } from "../../helpers/header.helper";
import { useNavigate } from "react-router";
import { pageTitles } from "../shared/constants";
import ButtonComponent from "../shared/button/button.component";
import { WatsappConversationCardIcon, WhatsappAuthenticationIcon, WhatsappMarketingIcon, WhatsappTemplateInfoIcon, WhatsappUtilityIcon } from "../../icon";
import { AppRoutes } from "../routes/route.path";


const AddWhatsappTemplateSetupComponent = () => {

    const navigate = useNavigate();

    const [selectedTemplateType, setSelectedTemplateType] = useState<{ MarketingCustom: boolean, MarketingCatalogue: boolean, UtilityCustom: boolean, AuthenticationCustom: boolean }>({ MarketingCustom: true, MarketingCatalogue: false, UtilityCustom: false, AuthenticationCustom: false })


    useEffect(() => {
        setHeaderTitle(pageTitles.TEMPLATES);
        setBackHandler(() => navigate(-1));
    }, []);

    const handleTemplateTypeSelection = (selectedType) => {
        setSelectedTemplateType({ MarketingCustom: selectedType === "MarketingCustom", MarketingCatalogue: selectedType === "MarketingCatalogue", UtilityCustom: selectedType === "UtilityCustom", AuthenticationCustom: selectedType === "AuthenticationCustom" })
    }

    return (
        <div className='w-p-100 h-p-100 bg-color-grid d-flex justify-center align-center'>
            <div className='w-p-96 h-p-96 bg-color-secondary br-2 d-flex justify-center align-center'>
                <div className="w-p-60 h-p-100 d-flex flex-direction">
                    <div className="w-p-86 h-10 d-flex justify-center align-center h4-semibold color-nav-bar-font-color mx-auto">
                        <div className="color-primary-light">
                            Set up Template&nbsp;&nbsp;
                        </div>
                        <div className="bb-bottom-nav-bar-font-color w-2">

                        </div>
                        <div>
                            &nbsp;&nbsp;Edit & Preview&nbsp;&nbsp;
                        </div>
                        <div className="bb-bottom-nav-bar-font-color w-2">

                        </div>
                        <div>
                            &nbsp;&nbsp;Submit for review
                        </div>
                    </div>
                    <div className="w-p-100 d-flex flex-direction">
                        <div className="w-p-86 d-flex align-center h4-semibold mx-auto">
                            Choose a Category
                        </div>
                        <div className="w-p-86 d-flex align-center color-nav-bar-font-color h6-medium mx-auto mb-1">
                            Choose the category that best describes your message template. Then, select the type of message that you want to send
                        </div>
                    </div>
                    <div className="w-p-100 h-p-70 d-flex flex-direction justify-between">
                        <div className="w-p-86 h-p-40 bg-color-secondary d-flex flex-direction box-shadow-whatsapp-template-type br-2 mx-auto">
                            <div className="w-p-100 h-p-34 d-flex justify-between">
                                <div className="w-p-48 h-p-100 d-flex justify-center">
                                    <div className="h-p-100 w-p-88 h4-semibold d-flex align-center">
                                        <WhatsappMarketingIcon className="mr-2" /> Marketing
                                    </div>
                                </div>
                                <div className="w-p-48 h-p-100 d-flex justify-center">
                                </div>
                            </div>
                            <div className="w-p-100 h-p-66 d-flex justify-between">
                                <div className="w-p-48 h-p-100 d-flex justify-center">
                                    <div className={`max-h-16 min-h-10 w-p-88 add-phone-number-paper-border br-1 c-pointer whatsapp-template-type ${selectedTemplateType.MarketingCustom && "whatsapp-template-type-active"}`} onClick={() => handleTemplateTypeSelection("MarketingCustom")}>
                                        <div className="mt-1 pl-2 d-flex align-end h6-bold ml-auto">
                                            <div className={`w-2 h-2 add-phone-number-paper-border br-p-50 mr-1 circle d-flex justify-center align-center ${selectedTemplateType.MarketingCustom && "whatsapp-template-type-active"}`}>
                                                {selectedTemplateType.MarketingCustom && <div className="bg-color-primary-light w-1 h-1 br-p-50"></div>}
                                            </div>
                                            Custom
                                        </div>
                                        <div className="h-p-60 h6-medium d-flex align-center color-nav-bar-font-color pl-2 pr-1 mt-1">
                                            Send promotions or announcements to increase awareness and engagement.
                                        </div>
                                    </div>
                                </div>
                                <div className="w-p-48 h-p-100 d-flex justify-center">
                                    <div className={`max-h-16 min-h-10 w-p-88 add-phone-number-paper-border br-1 c-pointer whatsapp-template-type ${selectedTemplateType.MarketingCatalogue && "whatsapp-template-type-active"}`} onClick={() => handleTemplateTypeSelection("MarketingCatalogue")}>
                                        <div className="mt-1 pl-2 d-flex align-end h6-bold ml-auto">
                                            <div className={`w-2 h-2 add-phone-number-paper-border br-p-50 mr-1 circle d-flex justify-center align-center ${selectedTemplateType.MarketingCatalogue && "whatsapp-template-type-active"}`}>
                                                {selectedTemplateType.MarketingCatalogue && <div className="bg-color-primary-light w-1 h-1 br-p-50"></div>}
                                            </div>
                                            Catalogue
                                        </div>
                                        <div className="h-p-60 h6-medium d-flex align-center color-nav-bar-font-color pl-2 pr-1 mt-1">
                                            Send messages about your entire catalogue or multiple products from it.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-p-86 h-p-56 d-flex justify-between mx-auto">
                            <div className="w-p-48 h-p-100 bg-color-secondary d-flex flex-direction box-shadow-whatsapp-template-type br-2">
                                <div className="h-p-25 w-p-88 h4-semibold d-flex align-center mx-auto">
                                    <WhatsappUtilityIcon className="mr-2" /> Utility
                                </div>
                                <div className="w-p-100 h-p-45 d-flex justify-center">
                                    <div className={`max-h-16 min-h-10 w-p-88 add-phone-number-paper-border br-1 c-pointer whatsapp-template-type ${selectedTemplateType.UtilityCustom && "whatsapp-template-type-active"}`} onClick={() => handleTemplateTypeSelection("UtilityCustom")}>
                                        <div className="mt-1 pl-2 d-flex align-end h6-bold ml-auto">
                                            <div className={`w-2 h-2 add-phone-number-paper-border br-p-50 mr-1 circle d-flex justify-center align-center ${selectedTemplateType.UtilityCustom && "whatsapp-template-type-active"}`}>
                                                {selectedTemplateType.UtilityCustom && <div className="bg-color-primary-light w-1 h-1 br-p-50"></div>}
                                            </div>
                                            Custom
                                        </div>
                                        <div className="h-p-60 h6-medium d-flex align-center color-nav-bar-font-color pl-2 pr-1 mt-1">
                                            Send messages about an existing order or account.
                                        </div>
                                    </div>
                                </div>
                                <div className="w-p-100 h-p-30 d-flex justify-center align-start">
                                    <ButtonComponent ButtonLabel="View pre-approved templates" Variant={"primary-btn"} ClassName="w-p-88" />
                                </div>
                            </div>
                            <div className="w-p-48 h-p-100 bg-color-secondary d-flex flex-direction box-shadow-whatsapp-template-type br-2">
                                <div className="h-p-25 w-p-90 h4-semibold d-flex align-center mx-auto">
                                    <WhatsappAuthenticationIcon className="mr-2" />  Authentication
                                </div>
                                <div className="w-p-100 h-p-45 d-flex justify-center">
                                    <div className={`max-h-16 min-h-10 w-p-88 add-phone-number-paper-border br-1 c-pointer whatsapp-template-type ${selectedTemplateType.AuthenticationCustom && "whatsapp-template-type-active"}`} onClick={() => handleTemplateTypeSelection("AuthenticationCustom")}>
                                        <div className="mt-1 pl-2 d-flex align-end h6-bold ml-auto">
                                            <div className={`w-2 h-2 add-phone-number-paper-border br-p-50 mr-1 circle d-flex justify-center align-center ${selectedTemplateType.AuthenticationCustom && "whatsapp-template-type-active"}`}>
                                                {selectedTemplateType.AuthenticationCustom && <div className="bg-color-primary-light w-1 h-1 br-p-50"></div>}
                                            </div>
                                            Custom
                                        </div>
                                        <div className="h-p-60 h6-medium d-flex align-center color-nav-bar-font-color pl-2 pr-1 mt-1">
                                            Send messages about an existing order or account.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-p-86 h-p-16 d-flex align-center mx-auto">
                        <ButtonComponent ButtonLabel={"Next"} OnClick={() => { navigate(AppRoutes.ADD_WHATSAPP_TEMPLATES_EDIT_AND_PREVIEW.replace(":template-type", selectedTemplateType.MarketingCustom ? "MarketingCustom" : selectedTemplateType.MarketingCatalogue ? "MarketingCatalogue" : selectedTemplateType.UtilityCustom ? "UtilityCustom" : selectedTemplateType.AuthenticationCustom && "AuthenticationCustom")) }} Variant={"primary-btn"} ClassName="ml-auto"></ButtonComponent>
                    </div>
                </div>
                <div className="w-p-40 h-p-100 d-flex flex-direction align-center">
                    <div className="w-p-100 h-p-4 d-flex justify-center align-center h4-semibold color-nav-bar-font-color">
                    </div>
                    <div className={`h-p-90 w-p-80 add-phone-number-paper-border br-3 c-pointer d-flex align-center flex-direction min-w-40`}>
                        <div className="w-p-88 h-p-86 max-w-38 min-w-38 mt-4">
                            <div className="whatsapp-template-background w-p-100 h-p-100 br-3 d-flex justify-center">
                                <div className="message received w-30 h-36 mt-4 d-flex flex-direction align-center">
                                    <div className="w-28 h-16 mt-1 d-flex justify-center align-center">
                                        <WatsappConversationCardIcon className="w-p-100 h-p-100"/>
                                    </div>
                                    <div className="w-30 h-10 bb-primary-background-pink-2 h5-medium d-flex justify-center">
                                        <div className="w-28 h-p-100 d-flex justify-center align-center color-nav-bar-font-color">
                                            Hey! Welcome to Kastech! We are your AI-powered maestro for this ride. What name do you go by?
                                        </div>
                                    </div>
                                    <div className="w-30 h-5 color-primary-light bb-primary-background-pink-2 d-flex justify-center align-center h5-medium">
                                        Shop now
                                    </div>
                                    <div className="w-28 h-5 color-primary-light d-flex justify-center align-center h5-medium">
                                        Copy code
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-p-80 h-p-20 max-w-38 min-w-38 d-flex justify-center align-center h6-regular flex-direction color-secondary-light-hover">
                            <div className="d-flex">
                                <WhatsappTemplateInfoIcon className="mr-1" width={12} height={12} />
                                <span>This template is good for order confirmations,</span>
                            </div>
                            <div>account update, receipts, reminders, billing.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AddWhatsappTemplateSetupComponent;